import React from 'react';
import PropTypes from 'prop-types';
import { PropTypeBn } from '@blockcatio/tabby-library/lib/utilities/PropTypeBn';
import EthereumAddress from '@blockcatio/tabby-library/lib/components/EthereumAddress';
import AddressImage from '@blockcatio/tabby-library/lib/components/AddressImage';
import FormattedWei from '@blockcatio/tabby-library/lib/components/FormattedWei';

const AccountInfo = ({
  address,
  balance,
  networkName,
  onWalletChange,
  catBalance,
  formattedTokenBalance,
  tokenSymbol,
}) => (
  <div className={`account-info white-box item-box small ${address ? 'logged-in' : 'logged-out'}`}>
    <h2 className="section-header">
      Account
      {address && <AddressImage address={address} className="address-image" />}
    </h2>
    <div className="inner">
      {address ? (
        <ul>
          <li>
            <h3>Address:</h3>
            <div>
              <EthereumAddress address={address} showImage={false} />
            </div>
          </li>
          <li>
            <h3>Network:</h3>
            <span className="network-name">{networkName}</span>
          </li>
          <li>
            <h3>ETH Balance:</h3>
            <FormattedWei wei={balance} suffix="" />
          </li>
          <li>
            <h3>CAT Balance:</h3>
            <FormattedWei wei={catBalance} suffix="" />
          </li>
          {tokenSymbol &&
            formattedTokenBalance && (
              <li>
                <h3>{tokenSymbol} Balance:</h3>
                {formattedTokenBalance}
              </li>
            )}
          <li>
            <p>Not the wallet you want to use?</p>
            <button name="changeWallet" type="button" onClick={onWalletChange}>
              Click here to change it.
            </button>
          </li>
        </ul>
      ) : (
        <p>No account information available.</p>
      )}
    </div>
  </div>
);

AccountInfo.defaultProps = {
  networkName: 'No Network Found',
  balance: null,
  catBalance: null,
  onWalletChange: () => null,
  formattedTokenBalance: null,
  tokenSymbol: '',
};

AccountInfo.propTypes = {
  address: PropTypes.string.isRequired,
  balance: PropTypeBn,
  networkName: PropTypes.string,
  catBalance: PropTypeBn,
  onWalletChange: PropTypes.func,
  formattedTokenBalance: PropTypes.node,
  tokenSymbol: PropTypes.string,
};

export default AccountInfo;



// WEBPACK FOOTER //
// ./src/components/AccountInfo.js